// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-settings .page-sizes {\n  height: 20px;\n  line-height: 20px;\n  font-size: 13px;\n}\n.layout-settings .page-sizes.disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.layout-settings .page-sizes > div {\n  min-width: 20px;\n  text-align: center;\n}\n.layout-settings .page-sizes .selected {\n  background-color: var(--v-date-base);\n  border-radius: 8px;\n}", ""]);
// Exports
module.exports = exports;
